import * as axios from "axios";
import CONFIG from "../../config";
import { getAuthHeader } from "../../utils";
import { Link, NavLink, BrowserRouter, useHistory } from "react-router-dom";

//get all state
export const selectState = (model) => {
  const url = `${CONFIG.BASE_URL}/master/get-state-list`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//get district details
export const selectDistrict = (model) => {
  const url = `${CONFIG.BASE_URL}/master/get-district-list`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const selectFilterCities = (model) => {
  const url = `${CONFIG.BASE_URL}/master/get-district-filter`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//Get course Details
export const GetCourses = (modal) => {
  const url = `${CONFIG.BASE_URL}/master/get-courses-list`;
  return axios.post(url, modal, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//Get skill Details
export const GetSkill = (modal) => {
  const url = `${CONFIG.BASE_URL}/master/get-skill-list`;
  return axios.post(url, modal, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//get all sector
export const selectSector = (model) => {
  const url = `${CONFIG.BASE_URL}/master/get-sector-list`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//get all City
export const getCity = () => {
  const url = `${CONFIG.BASE_URL}/master/get-city-list`;
  return axios.get(url, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const getUniversity = (model) => {
  const url = `${CONFIG.BASE_URL}/recruiter-university/list.json`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const addNotification = (model) => {
  const url = `${CONFIG.BASE_URL}/notification/add-notification`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const getNotification = (model) => {
  const url = `${CONFIG.BASE_URL}/notification/get-list`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const UpdateNotification = (model) => {
  const url = `${CONFIG.BASE_URL}/notification/update-status`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const Unreadnotificationcount = (model) => {
  const url = `${CONFIG.BASE_URL}/notification/unread-notification`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};


export const Changestatussector = (model) => {
  const url = `${CONFIG.BASE_URL}/master/statussector`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const Changestatusskill = (model) => {
  const url = `${CONFIG.BASE_URL}/master/status-skill`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const Changestatuscourse = (model) => {
  const url = `${CONFIG.BASE_URL}/master/status-course`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const Changestatusstate = (model) => {
  const url = `${CONFIG.BASE_URL}/master/status-state`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};